import React, {useEffect} from 'react';
import {setTabTitle} from "../../common/fusion-ui/utils/ReactUtils";
import {useNavigate} from "react-router-dom";
import {AdminKeys, AdminModuleRouteUrls, AdminModules} from "../config/AdminConfig";
import {useConfig} from "../context/ConfigProvider";
import {ThemedButton} from "../../common/components";

const _404Page = React.memo(() => {
    const TAG = '_404Page';
    const navigate = useNavigate();
    const {updateConfig} = useConfig();

    useEffect(() => {
        setTabTitle('404');
        updateConfig(AdminKeys.tracker_currPageModule, '404');
        updateConfig(AdminKeys.tracker_currPageTag, TAG);
    }, []);
    return (<div className={'position-relative w-100 h-100'}>
        <div id={"error-page"}>
            <div className={"content"}>
                <h2 className="header" data-text="404">
                    404</h2>
                <h4 className={''}>
                    {`Opps! Page not found`}
                </h4>
                <p className={'fs-normal'}>
                    {`Sorry, the page you're looking for doesn't exist.`}
                </p>
                <div className={"btnsxmt-3"}>
                    <ThemedButton
                        className={'px-5 fs-xl fw-semi-bold'}
                        text={'Go to Home'}
                        sleek={true}
                        href={AdminModuleRouteUrls[AdminModules.Dashboard]}
                    />
                </div>

                <div className={"mt-4"}>
                    <label
                        className={'px-2 py-1 fs-normal m-0 p-0 footer-link select-none'}
                        onClick={() => {
                            navigate(-1);
                        }}
                    >Go back</label>
                </div>
            </div>
        </div>
    </div>);
});

export default _404Page;
